<template>
  <div>
    <el-table
      :data="checkboxData"
      @row-click="selection"
      :load="load"
      style="margin-bottom: 20px; width: 300px"
      row-key="funcId"
      border
      lazy
      ref="table"
      default-expand-all
      :tree-props="{ children: 'sons' }"
    >
      <el-table-column
        label="功能权限"
        width="250px"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope" v-if="scope.row.isShow != 0">
          <el-checkbox
            v-if="isShow"
            :disabled="$route.query.roleType == 0 || $route.query.roleType == 1"
            @change="changebox(scope.row, checkboxData)"
            :value="scope.row.selected"
          ></el-checkbox>
          <span class="label_check moreWord">{{ scope.row.funcName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数据权限" width="1px">
        <template slot-scope="scope">
          <template v-if="scope.row.isShow == 3 || scope.row.isLeaf == true">
            <template v-for="(item, index) in powerList">
              <span :key="index">
                <el-checkbox
                  v-model="scope.row.powerValue"
                  :label="item.value"
                  :disabled="disabledFlag"
                  @change="checkboxGroup(item, scope.row, checkboxData)"
                ></el-checkbox>
                <span
                  class="label_check"
                  @click="checkBoxC(item, scope.row, checkboxData)"
                  >{{ item.name }}</span
                >
              </span>
            </template>
            <!--            </el-checkbox-group>-->
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作权限" width="1px">
        <template
          slot-scope="scope"
          v-if="scope.row.isShow == 3 || scope.row.isLeaf == true"
        >
          <template v-for="item1 in scope.row.operationCodeBos">
            <div :key="item1.id" class="cellSpan">
              <el-checkbox
                v-model="item1.selected"
                :label="item1.id"
                :disabled="disabledFlag || scope.row.checkSelected"
                @change="handleCheckedChange(item1, scope.row, checkboxData)"
              ></el-checkbox>
              <span class="label_check">{{ item1.optname }}</span>
              <!--              v-html="showNameFour(index1, item1.optname)"-->
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 所在部门-->
    <el-sorting-selector
      :dialogVisible.sync="dialogVisible"
      :staff="staff"
      :title="Title"
      :titleSubtotal="titleSubtotal"
      @deleteStaff="deleteStaff"
      @myDetermine="myDetermine"
      @handleClose="myDetermine"
      @gitSelectedStaff="getSelectedStaff"
      ref="sorgtingDOW"
    >
      <template slot="sortingSelectorTree">
        <el-org-tree
          :autoCode="autoCode"
          :defaultKeys="defaultKeys"
          :expandedKeys="expandedKeys"
          :fetchSuggestions="searchQuery"
          :isCache="true"
          :loadNode="loadNode"
          :placeholder="placeholder"
          @leftOrgTree="handleLeftOrgTree"
          @select="handleSelect"
          @slectOrgSuccess="slectOrgSuccess"
          v-if="leftLevelBelowisShow"
        >
          <template slot="up" slot-scope="{ item }">
            <div :title="item.value" style="display: flex">
              <div :title="item.value" class="orgName">
                <i
                  :class="handleIconClass(item)"
                  class="orgIcon"
                  style="color: #0089ef"
                ></i>
                <span style="margin-left: 5px">{{ item.value }}</span>
              </div>
              <p class="orgFullName">{{ item.abbrName }}</p>
            </div>
          </template>
          <template slot="upTree" slot-scope="{ node }">
            <i
              :class="handleIconClass(node.data, node.level)"
              class="orgIcon"
              style="margin-right: 10px"
            ></i>
            <span>{{ node.label }}</span>
            <i class="icon-ccui-check orgIcon" v-show="node.checked"></i>
          </template>
        </el-org-tree>
      </template>
      <template slot="sortingSelectorRight">
        <div class="el-dialog-box2 el-dialog-box" style="width: 485px">
          <span
            style="height: 20px; font-size: 14px; font-weight: 500; padding: 10px 20px; color: #4a4a4a; line-height: 20px; display: block; border-bottom: 1px solid #f1f1f1"
            >{{ titleSubtotal }}</span
          >
          <span
            :key="i"
            class="custom-tree-node"
            style="display: block; position: relative; margin: 5px 35px"
            v-for="(item, i) in staff"
          >
            <span
              style="position: relative; left: -10px; color: #d8d8d8"
            ></span>
            <span
              class="el-dialog-box2-txt1"
              style="width: 6px; height: 6px; background: #0089ef; display: block; position: absolute; top: 7px; left: -15px; border-radius: 6px"
              v-if="!item.data.isShow"
            ></span>
            <span :title="item.data.abbrName" class="el-dialog-box2-txt">{{
              item.data.abbrName
            }}</span>
            <span
              style="cursor: pointer; color: #d8d8d8; margin-right: 10px; float: right"
              ><i @click="deleteStaff(item)" class="el-icon-close"></i
            ></span>
            <span
              :title="item.data.orgFullName"
              class="el-dialog-box2-txt2"
              style="font-size: 13px; display: block; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #999999"
              >{{ item.data.orgFullName }}</span
            >
          </span>
        </div>
      </template>
    </el-sorting-selector>
  </div>
</template>

<script>
import {
  getdepartment,
  getdepartmentSearch,
  getdepartmentById
} from "../api/item-list";

export default {
  name: "checkboxTable1",
  props: {
    checkboxData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    powerList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    makeList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabledFlag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShow: true,
      value: "1",
      powerValue: ["1"],
      selecFlag: false,
      //  所在部门
      choseCheck: [],
      dialogVisible: false, // 所在部门
      selectorList: [],
      Title: "指定部门",
      titleSubtotal: "已选择部门(0)",
      props: {
        label: "name",
        children: "children"
      },
      autoCode: "",
      placeholder: " 请输入部门定位查找",
      count: 1,
      tableListParam: {},
      param: {
        parentId: "",
        flag: 0 // 展示层级 0 公司 1部门 2 成员
      },
      leftLevelBelowisShow: true,
      leftOrgTreea: "",
      defaultProps: {
        label: "orderName",
        id: "partyId",
        children: "child",
        isLeaf: "isLeaf"
      },
      expandedKeys: [],
      defaultKeys: [],
      nodeItem: [],
      // '206228','3859395','206199','206208'
      staff: [
        // { id: 18, data: { orderName: "三全鲜食17", partyId: 18 } }
      ],
      expandedKey: [],
      rowData: {},
      dataCheck: [],
      saveDetpId: []
    };
  },
  mounted() {
    console.log(this.makeList);
  },
  methods: {
    load(tree, treeNode, resolve) {
      console.log(tree);
      console.log(treeNode);
    },
    selection(item) {
      this.selectionData = item;
    },
    // 功能权限
    changebox(item, checkboxData) {
      this.isShow = false;
      this.isShow = true;
      if (item.selected == true) {
        this.$set(item, "selected", false);
        // item.selected = false;
        item.isUseable = 0;
        item.checkSelected = true;
        item.dataType = 0;
      } else {
        item.dataType = 1;
        item.selected = true;
        // this.$set(item,'selected',true)
        item.isUseable = 1;
        item.checkSelected = false;
      }
      if (item.sons.length > 0) {
        item.sons.map(i => {
          i.selected = item.selected;
          i.isUseable = item.isUseable;
          if (i.sons.length) {
            i.sons.map(j => {
              j.selected = i.selected;
              j.isUseable = i.isUseable;
            });
          }
        });
      }
      checkboxData.forEach(i => {
        if (i.sons.length > 0) {
          // console.log(i.sons,'i.sons')
          i.sons.forEach(h => {
            if (h.sons.length > 0) {
              h.sons.forEach(k => {
                // console.log( h.sons,' h.sons')
                // if (k.funcId == item.funcId) {
                if (h.sons.some(sonsItem => sonsItem.selected == true)) {
                  h.selected = true;
                  h.isUseable = 1;
                } else {
                  h.selected = false;
                  h.isUseable = 0;
                  k.checkSelected = true;
                }
                if (i.sons.some(sonsItem => sonsItem.selected == true)) {
                  i.selected = true;
                  i.isUseable = 1;
                } else {
                  i.selected = false;
                  i.isUseable = 0;
                }
              });
            } else {
              // if (h.funcId == item.funcId) {
              if (i.sons.some(sonsItem => sonsItem.selected == true)) {
                i.selected = true;
                i.isUseable = 1;
                h.checkSelected = false;
              } else {
                i.selected = false;
                i.isUseable = 0;
                h.checkSelected = true;
              }
              // }
            }
          });
        }
      });
      this.$emit("childrenSelected", checkboxData);
    },
    // 数据权限
    checkboxGroup(index, item, checkboxData) {
      if (index.value == 3) {
        this.checkBoxC(index, item);
        return;
      }
      item.powerValue.push(index);
      item.powerValue = item.powerValue.filter(item => item === index.value);
      // this.checkBoxC(item);
      console.log(item);
      // item.dataDeptIds = "";
      this.changeCheckData(item, checkboxData);
    },
    changeCheckData(item, checkboxData) {
      this.isShow = false;
      this.isShow = true;
      if (item.powerValue.length > 0) {
        item.dataType = Number(item.powerValue[0]);
        item.selected = true;
        item.isUseable = 1;
        item.checkSelected = false;
      } else {
        item.selected = false;
        item.isUseable = 0;
        item.operationCodeBos.forEach(w => {
          w.selected = false;
          w.isUseable = 0;
        });
        item.checkSelected = true;
        item.dataType = 0;
      }
      checkboxData.forEach(i => {
        if (i.sons.length > 0) {
          i.sons.forEach(h => {
            if (h.sons.length > 0) {
              h.sons.forEach(k => {
                // if (k.funcId == item.funcId) {
                if (h.sons.some(sonsItem => sonsItem.selected == true)) {
                  h.selected = true;
                  h.isUseable = 1;
                } else {
                  h.selected = false;
                  h.isUseable = 0;
                  k.checkSelected = true;
                }
                if (i.sons.some(sonsItem => sonsItem.selected == true)) {
                  i.selected = true;
                  i.isUseable = 1;
                } else {
                  i.selected = false;
                  i.isUseable = 0;
                }
                // }
              });
            } else {
              // if (h.funcId == item.funcId) {
              if (i.sons.some(sonsItem => sonsItem.selected == true)) {
                i.selected = true;
                i.isUseable = 1;
                h.checkSelected = false;
              } else {
                i.selected = false;
                i.isUseable = 0;
                h.checkSelected = true;
              }
              // }
            }
          });
        }
      });
      this.$emit("childrenSelected", checkboxData);
    },
    handleCheckedChange(index, item, checkboxData) {
      index.selected = !index.selected;
      index.selected = !index.selected;
      if (index.selected == true) {
        item.menuOperationBos.push({
          id: index.id,
          optId: index.id
        });
      } else {
        item.menuOperationBos.forEach((item1, index1) => {
          if (item1.optId == index.id) {
            item.menuOperationBos.splice(index1, 1);
          }
        });
      }
      if (item.menuOperationBos.length > 0) {
        item.selected = true;
        item.checkSelected = false;
      } else {
        if (item.dataType != "0") {
          item.selected = true;
          item.isUseable = 1;
          item.checkSelected = false;
        } else {
          item.selected = false;
          item.isUseable = 0;
          item.checkSelected = true;
        }
      }
      checkboxData.forEach(item2 => {
        item2.sons.forEach(item3 => {
          if (item3.sons.length > 0) {
            if (item3.sons.some(sonsItem => sonsItem.selected == true)) {
              item3.selected = true;
              item3.isUseable = 1;
            } else {
              item3.selected = false;
              item3.isUseable = 0;
            }
          } else {
            if (item2.sons.some(sonsItem => sonsItem.selected == true)) {
              item2.selected = true;
              item3.isUseable = 1;
            } else {
              item2.selected = false;
              item3.isUseable = 0;
            }
          }
        });
      });
      this.$emit("childrenSelected", checkboxData);
    },
    handleShows() {
      this.$refs.sorgtingDOW.sortingSelectorWidth = "848px";
      // this.staff.map(item => {
      //   item.data.isShow = true;
      //   // if(this.rowData.isSave == false){
      //   //   item.data.isShow = true;
      //   //   this.defaultKeys = [];
      //   // }else{
      //   //   item.data.isShow = false;
      //   // }
      //
      // });
      this.staff.splice();
      this.dialogVisible = true;
      this.titleSubtotal = `已选择部门(${this.staff.length}个)`;
    },
    deleteStaff(data) {
      console.log(data);
      this.leftOrgTreea.setChecked(data.data.partyId, false);
      this.staff.forEach((i, idx) => {
        if (i.data.partyId == data.data.partyId) {
          this.staff.splice(idx, 1);
        }
      });
      this.defaultKeys.forEach((i, idx) => {
        if (i == data.data.partyId) {
          this.defaultKeys.splice(idx, 1);
        }
      });
      this.titleSubtotal = `已选择部门(${this.staff.length})`;
    },
    // 选择部门确定
    getSelectedStaff(data) {
      console.log(data);
      if (data.length == 0) {
        this.$message({
          message: "至少选择一个部门",
          type: "error",
          duration: 3000,
          ccuiCustom: true,
          showClose: true
          // offset: document.body.clientHeight / 2 - 21
        });
        this.dialogVisible = true;
        return;
      }
      this.choseCheck = [];
      data.forEach(item => {
        this.saveDetpId.forEach(h => {
          if (h == item.data.deptId) {
            this.$set(item.data, "hasagoDeptId", false);
          }
        });
        this.choseCheck.push(item.data);
        console.log(this.choseCheck);
        // this.defaultKeys.push(item.data.partyId)
        this.choseCheck.forEach(i => {
          if (i.autoCode.indexOf("-") > -1) {
            // this.expandedKeys = [];
            // this.defaultKeys = [];
            i.autoCode = i.autoCode.split("-");
            console.log(i.autoCode);
            i.autoCode.forEach((h, index) => {
              if (h == "") {
                i.autoCode.splice(index, 1);
              }
            });
            console.log(i.autoCode);
            let autoCode = i.autoCode.slice(0, i.autoCode.length - 1);
            console.log(autoCode);
            autoCode.forEach(i => {
              this.expandedKeys.push(i);
            });
            let autoCode1 = i.autoCode.slice(
              i.autoCode.length - 1,
              i.autoCode.length
            );
            console.log(autoCode1);
            autoCode1.forEach(i => {
              this.defaultKeys.push(i);
            });
          }
        });
        this.expandedKeys = [...new Set(this.expandedKeys)];
        this.defaultKeys = [...new Set(this.defaultKeys)];
        // console.log(this.expandedKeys);
        this.selectUser();
      });
    },
    // 选择部门点击树
    slectOrgSuccess(obj, node, tree) {
      // if (!node.checked) {
      //   this.$set(node,'checked', false);
      // }
      console.log(obj);
      console.log(this.staff);
      console.log(this.defaultKeys, "2222");
      if (node.data.orgType == "1") {
        console.log(node);
        this.$set(node, "checked", true);
        this.$set(node.data, "hasagoDeptId", false);
        this.saveDetpId.push(node.data.deptId);
        this.staff.unshift(node);
        let obj = {};
        this.staff = this.staff.reduce(function(item, next) {
          obj[next.data.partyId]
            ? ""
            : (obj[next.data.partyId] = true && item.push(next));
          return item;
        }, []);
        // let staff1 = [];
        // staff.forEach((item)=>{
        //   if(staff1.indexOf(item.data.partyId) == -1){
        //     staff1.push(item)
        //   }
        // })
        // this.staff = staff1;
        // this.staff = Array.from(new Set(this.staff));
        console.log(this.staff);
        this.titleSubtotal = `已选择部门(${this.staff.length})`;
      }
      //单选
      // if (node.level === 4 || node.level === 3) {
      //   console.log(node);
      //   this.$set(node, "checked", true);
      //   this.$set(this.nodeItem, "checked", false);
      //   if (node.checked === true) {
      //     this.leftOrgTreea.setCheckedKeys([obj.partyId]);
      //   }
      //   let objadd = this.leftOrgTreea.getCheckedNodes();
      //   let add = [
      //     {
      //       data: objadd[objadd.length - 1]
      //     }
      //   ];
      //   this.staff = add;
      //   console.log(this.staff);
      //   this.titleSubtotal = `已选择部门(${this.staff.length})`;
      // }
      if (obj.partyId) {
        this.tableListParam.partyId = obj.partyId;
      }
      this.nodeItem = node;
      if (obj.id) {
        this.tableListParam.id = Number(obj.id);
        sessionStorage.id = JSON.stringify(this.tableListParam.id);
        if (this.$refs.selectTabs) {
          this.$refs.selectTabs.getDataList(JSON.parse(sessionStorage.id), obj);
        }
      }
      if (obj.isLeaf) {
        sessionStorage.isLeaf = this.tableListParam.isLeaf;
      }
    },
    handleSelect(item) {
      console.log(item);
      this.expandedKeys = item.autoCode.split("-");
      this.leftLevelBelowisShow = false;
      this.$nextTick(() => {
        this.autoCode = item.autoCode;
        this.param.partyId = item.partyId;
        // this.defaultKeys.push(item.partyId)
        this.leftLevelBelowisShow = true;
      });
    },
    handleLeftOrgTree(data) {
      this.leftOrgTreea = data;
    },
    // 部门树懒加载数据
    loadNode(node, resolve) {
      if (node.level === 0) {
        getdepartment({ flag: 1 }).then(res => {
          return resolve(res.data.data);
        });
      }
      if (node.level > 0) {
        getdepartment({ flag: 1, parentId: node.data.partyId }).then(res => {
          console.log(res.data.data);
          return resolve(res.data.data[0].child);
        });
      }
    },
    // 部门树搜索
    searchQuery(queryString, cb) {
      getdepartmentSearch({
        flag: 3,
        branchName: queryString
      }).then(res => {
        console.log(res);
        cb(res.data.data.rows);
      });
      // var restaurants = this.restaurants;
      // var results = queryString
      //   ? restaurants.filter(this.createFilter(queryString))
      //   : restaurants;
      // // 调用 callback 返回建议列表的数据
      // cb(results);
      // if (sessionStorage.oldSeachData === queryString) {
      //   cb(this.resultJsonParse(sessionStorage.seachResult));
      // } else {
      //   let restaurants = this.restaurants;
      //   sessionStorage.seachResult = restaurants;
      //   cb(restaurants);
      // }
    },
    // 请求部门
    getdepartment() {
      getdepartment({ flag: 1 }).then(res => {
        res.data.data.forEach(item => {
          this.selectorList.push(item);
        });
      });
    },
    // 部门相关图标
    handleIconClass(i, w) {
      // let arr = [
      //   "icon-ccui-organization",
      //   "icon-ccui-unit",
      //   "icon-ccui-man-hollow",
      //   "icon-ccui-woman-hollow"
      // ];
      let keyClass = "";
      if (w === 3 || w === 4) {
        keyClass = "icon-ccui-unit";
      } else {
        keyClass = "icon-ccui-organization";
      }
      if (i.orgType === "0") {
        keyClass = "icon-ccui-organization is-leaf-org";
      }

      if (i.orgType === "1") {
        keyClass = "icon-ccui-unit is-leaf-org";
      }
      let obj = {};
      obj[keyClass] = true;
      return obj;
    },
    checkBoxC(item, Item) {
      console.log("item", item);
      console.log("Item", Item);
      console.log(this.defaultKeys);
      if (!this.disabledFlag && item.value == "3") {
        console.log("打开");
        // this.show = true;
        this.rowData = Item;
        this.dataCheck = this.checkboxData;
        // if(this.isSave == true){
        //   this.expandedKeys = [];
        //   this.defaultKeys = [];
        // }
        // this.defaultKeys = ['206228','3859395','206199','206208']
        if (this.rowData.dataDeptIds == "") {
          this.expandedKeys = [];
          this.defaultKeys = [];
        }
        this.getdept();
      }
    },
    //根据部门id获取选中部门
    getdept() {
      console.log(this.rowData);
      console.log(this.dataCheck);
      getdepartmentById({
        deptIds: this.rowData.dataDeptIds.split(",")
      }).then(res => {
        console.log(res);
        if (res.data.code == "0") {
          let arrStaff = res.data.data;
          let staff = [];
          arrStaff.forEach(item => {
            item.id = item.partyId;
            // this.$set(item, "isShow", false);
            staff.push({
              data: item
            });
          });
          console.log(this.defaultKeys);
          staff.map(item => {
            item.data.isShow = true;
            if (this.rowData.isSave == false) {
              item.data.isShow = true;
              this.defaultKeys = [];
            } else {
              this.rowData.dataDeptIdsCopy.forEach(i => {
                if (i.deptId == item.data.deptId) {
                  i.hasagoDeptId == false
                    ? (item.data.isShow = false)
                    : (item.data.isShow = true);
                }
              });
              if (item.data.isShow == true) {
                this.defaultKeys.forEach((i, idx) => {
                  if (i == item.data.partyId) {
                    this.defaultKeys.splice(idx, 1);
                  }
                });
              }
            }
          });
          let staffq = staff.filter(item => item.data.isShow == false);
          console.log(staffq);
          let staffq2 = staff.filter(item => item.data.isShow == true);
          console.log(staffq2);
          this.staff = staffq.length > 0 ? staffq.concat(staffq2) : staffq2;
          this.titleSubtotal = `已选择部门(${this.staff.length}个)`;
          this.handleShows();
        }
      });
    },
    selectUser() {
      this.rowData.powerValue.push("3");
      this.rowData.powerValue = this.rowData.powerValue.filter(
        item => item == "3"
      );
      // this.rowData.dataType = Number(this.rowData.powerValue[0]);
      if (this.rowData.powerValue.length > 0) {
        this.rowData.dataType = Number(this.rowData.powerValue[0]);
        this.rowData.selected = true;
        this.rowData.isUseable = 1;
        this.rowData.checkSelected = false;
      } else {
        this.rowData.selected = false;
        this.rowData.isUseable = 0;
        this.rowData.operationCodeBos.forEach(w => {
          w.selected = false;
          w.isUseable = 0;
        });
        this.rowData.checkSelected = true;
        this.rowData.dataType = 0;
      }
      let dataDeptIds = [];
      let dataDeptIdsCopy = [];
      this.dataCheck.forEach(item => {
        if (item.sons.length > 0) {
          item.sons.forEach(item1 => {
            if (item1.sons.length > 0) {
              item1.sons.forEach(item2 => {
                if (item1.sons.some(sonsItem => sonsItem.selected == true)) {
                  item1.selected = true;
                  item1.isUseable = 1;
                } else {
                  item1.selected = false;
                  item1.isUseable = 0;
                  item2.checkSelected = true;
                }
                if (item.sons.some(sonsItem => sonsItem.selected == true)) {
                  item.selected = true;
                  item.isUseable = 1;
                } else {
                  item.selected = false;
                  item.isUseable = 0;
                }
                if (item2.funcId == this.rowData.funcId) {
                  this.choseCheck.forEach(item3 => {
                    dataDeptIds.push(item3.deptId);
                    dataDeptIdsCopy.push({
                      deptId: item3.deptId,
                      hasagoDeptId: item3.hasagoDeptId
                    });
                    console.log(dataDeptIdsCopy);
                    item2.dataDeptIds = dataDeptIds.toString();
                    this.$set(item2, "dataDeptIdsCopy", dataDeptIdsCopy);
                  });
                }
              });
            } else {
              if (item.sons.some(sonsItem => sonsItem.selected == true)) {
                item.selected = true;
                item.isUseable = 1;
                item1.checkSelected = false;
              } else {
                item.selected = false;
                item.isUseable = 0;
                item1.checkSelected = true;
              }
            }
          });
        }
      });
      this.rowData.isSave = true;
      this.saveDetpId = [];

      this.$emit("childrenSelected", this.dataCheck);
    },
    //关闭取消按钮
    myDetermine() {
      // '11715804461','11715804458'
      console.log(this.rowData);
      if (this.rowData.dataDeptIds == "" && this.rowData.dataType == 0) {
        this.rowData.powerValue = [];
        // this.rowData.dataType = 0;
        this.rowData.OperationBos = [];
      } else {
        this.rowData.powerValue.push(this.rowData.dataType.toString());
        this.rowData.powerValue = this.rowData.powerValue.filter(
          item => item == this.rowData.dataType
        );
      }

      this.changeCheckData(this.rowData, this.dataCheck);
    },
    showNameFour(index, name) {
      if (index != 0 && (index + 1) % 4 == 0) {
        return (name += "<br/>");
      } else {
        return name;
      }
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-table__expand-icon {
  &.el-table__expand-icon--expanded {
    display: none !important;
  }
}

/deep/ .el-table__row {
  &.el-table__row--level-1 {
    .cell {
      .el-table__placeholder {
        display: none !important;
      }

      .el-table__indent {
        padding-left: 24px !important;
      }
    }
  }
}

/deep/ .el-table {
  td,
  th {
    border-right: 0px solid #edf2fc !important;
  }
}

/deep/ .el-checkbox__input.is-disabled.is-checked {
  // .el-checkbox__inner {
  //   background-color: #ff142f;
  //   border-color: #ff142f;
  // }

  .el-checkbox__inner::after {
    border-color: #ffffff;
  }

  .el-checkbox__label {
    color: #4a4a4a !important;
  }
}

/deep/ .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #4a4a4a !important;
}

/deep/ .el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #ffffff;
}

/deep/ .el-checkbox {
  margin-right: 10px;
}

/deep/ .el-checkbox__label {
  display: none !important;
}

.label_check {
  margin-right: 20px;
  cursor: pointer;
}
/deep/.el-table {
  .cellThree {
    .cell {
      height: auto;
      white-space: normal;
      overflow: auto;
      min-width: 80%;
      .cellSpan {
        //width:100px;
        display: inline-block;
      }
    }
  }
}
</style>
